import React, { useState } from 'react'

import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import {
  BUTTON_COLOR,
  BUTTON_THEME,
  Button,
  INPUT_THEME,
  Input,
  Icon,
  Pagination,
  usePagination,
} from '@st-operations/uikit/src/v2'
import pretty from '@st-operations/uikit/lib/pretty'

import Select from '_components/select'
import { checkAdmin, filterOrg, filterQuery, sortUsers } from './helper'

import './styles.scss'

const DeleteUserModal = ({ id, email, onClose, handleDeleteUser }) => {
  const handleDelete = () => {
    handleDeleteUser(id, email)
    setTimeout(onClose, 200)
  }

  return (
    <Dialog open={true} onClose={onClose}>
      <h2 className=" text-center text-lg font-bold mb-4">Are you sure?</h2>
      <div className=" mb-4">
        You are removing <b>{email}</b> as a collaborator. This user won't have access to DataSphere
        anymore.
      </div>
      <div className="flex justify-end">
        <Button onClick={handleDelete} color={BUTTON_COLOR.RED}>
          Yes! I'm sure
        </Button>
        <Button onClick={onClose} theme={BUTTON_THEME.GHOST}>
          Cancel
        </Button>
      </div>
    </Dialog>
  )
}

const ManageCollaborators = ({ users, handleEditUser, handleDeleteUser, orgOptions }) => {
  const [query, setQuery] = useState('')
  const [orgSelected, setOrgSelected] = useState(null)
  const [sortBy, setSortBy] = useState({ type: null, direction: null })
  const [deleteUserModal, setDeleteUserModal] = useState(false)

  const sortedUsers = sortUsers(sortBy, filterOrg(orgSelected, filterQuery(query, users)))
  const { page, toPage } = usePagination(sortedUsers, 20)

  const handleSortBy = (type) => () => {
    if (sortBy.type === null || sortBy.type !== type) {
      return setSortBy({ type, direction: 'asc' })
    }
    if (sortBy.direction === 'asc') {
      return setSortBy({ type, direction: 'desc' })
    }
    if (sortBy.direction === 'desc') {
      return setSortBy({ type: null, direction: null })
    }
  }

  return (
    <div className="manage-collaborators">
      <div className="manage-collaborators">
        <div className="manage-collaborators__filters">
          <Input
            onChange={(value) => setQuery(value)}
            placeholder="Search users"
            theme={INPUT_THEME.SEARCH}
            value={query}
            iconStyle={{ left: 12, width: 16 }}
          />
          <Select
            placeholder="Filter by Org"
            options={orgOptions}
            onChange={(org) => setOrgSelected(org)}
            isClearable={true}
          />
          <Pagination
            options={{ length: page.quantity }}
            page={page.number - 1}
            onPageChange={(page) => toPage(page.label)}
          />
        </div>
        <div className="manage-collaborators__header">
          <div>
            Email
            <button onClick={handleSortBy('email')}>
              <Icon icon="sort" type="outline" height={14} width={14} />
            </button>
          </div>
          <div>
            Name
            <button onClick={handleSortBy('name')}>
              <Icon icon="sort" type="outline" height={14} width={14} />
            </button>
          </div>
          <div>
            Org
            <button onClick={handleSortBy('org')}>
              <Icon icon="sort" type="outline" height={14} width={14} />
            </button>
          </div>
          <div>Actions</div>
        </div>
        <hr />
        <div className="manage-collaborators__content">
          <For each="user" of={page.content}>
            <div key={user._id} className="manage-collaborators__row">
              <div>{user.email}</div>
              <div>{pretty(user.name ?? '-')}</div>
              <div>{pretty(user.org)}</div>
              <div>
                <button onClick={handleEditUser(user._id)} className="action-button">
                  <Icon icon="edit" type="outline" color="#3D3C68" width="20px" height="20px" />
                </button>
                <If condition={checkAdmin()}>
                  <button
                    onClick={() => setDeleteUserModal({ id: user._id, email: user.email })}
                    className="action-button"
                  >
                    <Icon
                      icon="trashcan"
                      type="outline"
                      color="#D92323"
                      width="20px"
                      height="20px"
                    />
                  </button>
                </If>
              </div>
            </div>
          </For>
        </div>
      </div>
      <If condition={deleteUserModal}>
        <DeleteUserModal
          {...deleteUserModal}
          handleDeleteUser={handleDeleteUser}
          onClose={() => setDeleteUserModal(false)}
        />
      </If>
    </div>
  )
}

export default ManageCollaborators
